module.exports = __webpack_public_path__ + "img/icon_ai1.9457a550.png";